"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATABASE_LARGE_DATA_POLICY = exports.DOCUMENT_PRODUCT_HARD_LIMIT_BYTES = void 0;
/** Product hard wall for one synchronized Y.js document. */
exports.DOCUMENT_PRODUCT_HARD_LIMIT_BYTES = 10_000_000;
exports.DATABASE_LARGE_DATA_POLICY = {
    rootMaterializationGuard: {
        rowHardLimit: 0,
        rationale: 'Product database rows are never materialized in the owning doc; this guard exists only to fail loud if a root-row write is attempted.',
    },
    database: {
        columnHardLimit: 128,
        rationale: 'Product database schemas stay bounded by a global column cap.',
    },
    ui: {
        visibleRowWindowLimit: 5000,
        visibleColumnWindowLimit: 50,
        defaultPageSize: 25,
        maxPageSize: 500,
        columnPageSize: 20,
        rationale: 'Canvas, note, and fullscreen views must render bounded visible windows.',
    },
    jobs: {
        bulkRowLimit: 5000,
        bulkColumnLimit: 128,
        automationBatchRowLimit: 5000,
        rowSearchResultLimit: 5000,
        materializationRowLimit: 5000,
        exportBatchRowLimit: 5000,
        rationale: 'Backend jobs read explicit bounded batches, not whole tables.',
    },
    ai: {
        defaultReadRowLimit: 100,
        maxReadRowLimit: 500,
        filterMaxDepth: 3,
        filterMaxPredicates: 16,
        filterMaxValues: 32,
        filterValueMaxLength: 512,
        contextRowWindowLimit: 200,
        contextSelectedRowLimit: 500,
        contextDefaultSampleRowLimit: 3,
        contextMaterializationBatchRowLimit: 100,
        contextMaterializationByteLimit: 512 * 1024,
        bulkRowLimit: 5000,
        rationale: 'AI tools preserve bounded selected rows, filter trees and values, project required columns, and materialize them in byte-budgeted batches.',
    },
    relationGraph: {
        maxDepth: 4,
        maxNodes: 200,
        maxEdges: 400,
        maxColumnsPerHop: 32,
        rationale: 'Relation graph reads stay explicitly bounded across traversal depth, materialized nodes, emitted edges, and projected columns.',
    },
    import: {
        inlineWarningRowThreshold: 4000,
        inlineWarningColumnThreshold: 100,
        inlineBlockRowThreshold: 5000,
        inlineBlockColumnThreshold: 128,
        inlineEstimatedByteWarningThreshold: 256 * 1024,
        inlineEstimatedByteHardLimit: 512 * 1024,
        stagingRowHardLimit: 25_000,
        stagingColumnHardLimit: 128,
        stagingEstimatedByteHardLimit: 25 * 1024 * 1024,
        fixedColumnOverhead: 4,
        rationale: 'Import preflight separates inline UI budgets, queued sharded import routing, and current JSON/job staging limits.',
    },
    shard: {
        targetBytes: 256 * 1024,
        hardLimitBytes: 512 * 1024,
        writeAccountingOverheadBytes: 8 * 1024,
        cellValueWarningBytes: 128 * 1024,
        cellValueHardLimitBytes: 256 * 1024,
        rationale: 'Row-shard boundaries are byte-budget based.',
    },
    render: {
        kanbanGroupLimit: 12,
        kanbanRowsPerGroupLimit: 3,
        kanbanCardsPerGroupLimit: 20,
        rationale: 'Kanban keeps its initial mounted card grid below 1000 nodes; explicit show-more actions expand only the requested lane or group.',
    },
};
